module.exports = __webpack_public_path__ + "ky.svg?bae94ee77ef2bcfedc9990a4b4eaa4b7";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ky.svg
// module id = 857
// module chunks = 27